import { render, staticRenderFns } from "./PatientControlAvatar.vue?vue&type=template&id=d33c13f0&scoped=true&"
import script from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"
export * from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./PatientControlAvatar.vue?vue&type=style&index=0&id=d33c13f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33c13f0",
  null
  
)

export default component.exports